module.exports = __webpack_public_path__ + "img/GR122.898cb2f8.png";